import { Outlet } from 'react-router-dom';
import StaffResumeHeader from '@/components/StaffResumeHeader';
import { PageLink } from '@/components/TopPageLinks/TopPageLinks.component';
import { StaffMember } from '@/types/api/staffMember';
import * as Styles from './StaffMemberInfo.styles';

type Props = {
  topPageLinks: PageLink[];
  staffMember?: StaffMember;
  onDeleteClick?: () => void;
  onSetInactiveClick?: () => void;
  onSetActiveClick?: () => void;
};

const StaffMemberInfo = ({ topPageLinks, staffMember, onDeleteClick, onSetInactiveClick, onSetActiveClick }: Props): JSX.Element => {
  return (
    <div>
      <Styles.Navigation pageLinks={topPageLinks} />
      <StaffResumeHeader staffMember={staffMember} onDeleteClick={onDeleteClick} onSetInactiveClick={onSetInactiveClick} onSetActiveClick={onSetActiveClick} />
      <Outlet />
    </div>
  );
};

export default StaffMemberInfo;
